import usePagination from "src/customHooks/usePagination";
import PageHeader from "src/components/pageHeader";
import Pagination from "src/components/pagination";
import PageLoading from "src/components/pageLoading";
import { Topic } from "../entities/ai-topic.entity";
import { useGetAITopicsQuery, useCountAITopicsQuery, useGetUniqueCategoriesCountQuery } from "../ai-topic.service";
import AITopicsTable from "../components/ai-topics-table";
import { FaTags, FaLayerGroup } from "react-icons/fa";

const StatCard = ({ title, count, icon, colorClass, borderClass, bgClass }: any) => (
  <div className={`p-4 rounded-xl border ${borderClass} ${bgClass} shadow-sm flex items-center justify-between`}>
    <div>
      <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider mb-1">{title}</p>
      <h3 className="text-2xl font-bold text-gray-800">{count ?? "-"}</h3>
    </div>
    <div className={`p-3 rounded-full ${colorClass} bg-white bg-opacity-60`}>
      {icon}
    </div>
  </div>
);

const AITopicsPage = () => {
  const { data, numberOfPages, currentPage, next, prev, isSuccess, isError } =
    usePagination<Topic & { id: string }>({
      useGetDataQuery: useGetAITopicsQuery,
      useCountData: useCountAITopicsQuery,
    });

  // Fetch stats separately
  const { data: totalTopics } = useCountAITopicsQuery({ where: {} });
  const { data: uniqueCategoriesCount } = useGetUniqueCategoriesCountQuery();

  return (
    <div className="page_container space-y-6">
      <PageHeader text="AI Topics" />

      {/* Stats Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <StatCard
          title="Total Topics"
          count={totalTopics}
          icon={<FaTags className="text-xl text-purple-600" />}
          colorClass="text-purple-600"
          borderClass="border-purple-100"
          bgClass="bg-gradient-to-br from-purple-50 to-indigo-50"
        />
        <StatCard
          title="Unique Categories"
          count={uniqueCategoriesCount}
          icon={<FaLayerGroup className="text-xl text-blue-600" />}
          colorClass="text-blue-600"
          borderClass="border-blue-100"
          bgClass="bg-gradient-to-br from-blue-50 to-cyan-50"
        />
      </div>

      {isSuccess ? (
        <>
          <AITopicsTable data={data} />
          <Pagination numberOfPages={numberOfPages} currentPage={currentPage} prev={prev} next={next} />
        </>
      ) : isError ? (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
          <h3 className="text-lg font-semibold text-red-800 mb-2">Error Loading AI Topics</h3>
          <p className="text-red-600">There was an error fetching the AI topics data. Please check the console for more details.</p>
        </div>
      ) : (
        <PageLoading />
      )}
    </div>
  );
};

export default AITopicsPage;
